import { Component, OnInit } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import {MessageService} from 'primeng/api';
import { DialogService } from 'primeng/api';

@Component({
  selector: 'app-addonmember',
  templateUrl: './addonmember.component.html',
  styleUrls: ['./addonmember.component.css'],
  providers: [DialogService]
})


export class AddonmemberComponent implements OnInit {
  photo  : any;
  photoProof : any;
  associatedProof : any;
  addonList: any = [];
  amStateList: any = [];
  amCityList: any = [];
  amCountyList: any = [];
  amStateDropDisable:boolean = true;
  amCityDropDisable:boolean = true;
  addonCount: any;
  amForm: FormGroup;
  populateForm: any = {};
  addr: any = {};
  agelimit: any;
  yearlimit: any;
  yearRange: any;
  currentDate: any;
  eMaxLimit: any;
  am: any = {};
  uploadedFiles:any = {};
  otpShowHide: boolean = false;
  showOrHide: boolean = false;
  AMverified: boolean = false;
  amFormValid: boolean = true;
  draftMandatory: boolean = true;
  pidExpiryDisable: boolean = false;
  inProcess: boolean = false;
  relationshipWithCompany:any = [
    {label: 'OWNER', value: 'OWNER'},
    {label: 'EMPLOYEE', value: 'EMPLOYEE'},
    {label: 'PARTNER', value: 'PARTNER'}
  ];
  blockSpecial: RegExp = /^[^0-9<>*!@#$_%+=~`^{}()-/\\;:.,&|?\[\]'"]*$/;
  cardCreateStatus: any;
  completeAplhaNumeric: RegExp = /^[^<>*!@#$_%+=~`^{}()\\\/;:.,&|?\[\]'"]+$/;
  alphaNumberic: RegExp = /[a-z0-9]/i;
  addressLine1:string;
  addressLine2:string;
  cityName: string;
  countyName: string;
  postalCode: number;
  stateProvCode: string;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, public nms: NewmemberService, public messageService: MessageService) { }

  ngOnInit() {
    this.amForm = new FormGroup({
      status: new FormControl('', Validators.compose([
        Validators.required
      ])),
      firstName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      middleName: new FormControl(),
      lastName: new FormControl('', Validators.compose([
        Validators.required
      ])),
      mobile: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[5-9][0-9]{9}$')
      ])),
      relation: new FormControl('', Validators.compose([
        Validators.required
      ])),
      dob: new FormControl('', Validators.compose([
        Validators.required
      ])),
      buildingno: new FormControl('', Validators.compose([
        Validators.required
      ])),
      streetname: new FormControl('', Validators.compose([
        Validators.required
      ])),
      city: new FormControl('', Validators.compose([
        Validators.required
      ])),
      county: new FormControl('', Validators.compose([
        Validators.required
      ])),
      state: new FormControl('', Validators.compose([
        Validators.required
      ])),
      pinno: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6}$')
      ])),
      docType: new FormControl('', Validators.compose([
        Validators.required
      ])),
      STDLandLine: new FormControl(),
      whatsappNumber: new FormControl({disabled: true}),
      mailId: new FormControl('', Validators.compose([
        Validators.pattern('^[A-Za-z0-9._-]+[@][A-Za-z0-9._-]+[.][a-zA-Z]{2,5}$')
      ])),
      cardLic: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardExpiry: new FormControl('', Validators.compose([
        Validators.required
      ])),
      cardState: new FormControl('', Validators.compose([
        Validators.required
      ])),
      education: new FormControl({disabled: true}),
      income: new FormControl({disabled: true}),
      social: new FormControl({disabled: true}),
      isBusinessOwner: new FormControl(false),
    });
    this.populateForm = this.config.data.populateForm;
    this.addr = this.config.data.address;
    this.addonCount = this.config.data.count;
    this.am = this.config.data.am;

    if(this.config.data.address) {
      this.addr = this.config.data.address;
      this.am.addressLine1 = this.addr.businessAddressLine1;
      this.am.addressLine2 = this.addr.businessAddressLine2;
      this.am.stateProvCode = this.addr.businessStateProvCode;
      this.am.cityName = this.addr.businessCityName;
      this.am.postalCode = this.addr.businessPostalCode;
      this.am.countyName = this.addr.businessCountyName;
      this.addressLine1 = this.am.addressLine1;
      this.addressLine2 = this.am.addressLine2;
      this.cityName = this.am.cityName;
      this.stateProvCode = this.am.stateProvCode;
      this.postalCode = this.am.postalCode;
      this.countyName = this.am.countyName;
    }
    this.amStateList = [];
    this.amStateList.push(this.am.stateProvCode);
    this.amCityList = [];
    this.amCityList.push(this.am.cityName);
    this.getCountyByPincode(this.am.postalCode);
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == this.am.photoTypeCode) {
        if(list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
          if (this.am.expirationDt == null) {
            let currDate = new Date(localStorage.getItem('currDate'));
            this.am.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
          }
        } else {
          this.pidExpiryDisable = false;
          this.am.expirationDt = '';
        }
        if(list.maxLength > 0) {
          this.amForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
        } else {
          this.amForm.get('cardLic').setValidators([Validators.required]);
        }
        break;
      }
    }
    if(this.am.cardHolderDocuments) {
      this.uploadedFiles.cardHolderDocuments = this.am.cardHolderDocuments;
      for(let list of this.uploadedFiles.cardHolderDocuments) {
        if(list.documentType === "PHOTO") {
          this.photo = list;
        } else if(list.documentType === "PHOTO PROOF") {
          this.photoProof = list;
        } else if(list.documentType === "ASSOCIATED PROOF") {
          this.associatedProof = list;
        }
        list.ustatus = list.documentId != null ? true : false;
      }
    } else {
      this.am.cardHolderDocuments = [];
    }
    
    var date = new Date();
    this.currentDate = new Date();
    let tempDate = new Date();
    date.setFullYear( date.getFullYear() - 18 );
    this.agelimit = date;
    this.eMaxLimit = new Date(tempDate.setFullYear(tempDate.getFullYear() + 99));
    this.yearlimit = (this.agelimit.getFullYear() - 82) + ":" + this.agelimit.getFullYear();
    this.yearRange = this.currentDate.getFullYear() + ":" + this.eMaxLimit.getFullYear();
    this.cardCreateStatus = [{label: 'Active', value: 'A'}, {label: 'Draft', value: 'DRAFT'}];
  }

  resetOTP() {
      this.showOrHide = false;
      this.otpShowHide = false;
      this.am.landlineNbr= this.am.phoneNbr
  }

  ustatusUpdate(event, group, type) {
    if(!this.uploadedFiles[group]){
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({"ustatus": event, "documentType": type});
    } else {
      let check = 0;
      for(let list of this.uploadedFiles[group]) {
        if(list.documentType == type){
          check = 1;
          list.ustatus = event;
        }
      }
      if(check == 0) {
        this.uploadedFiles[group].push({"ustatus": event, "documentType": type});
      }
    }
  }

  updateUploadstatus(event, group, type) {
    if(!this.uploadedFiles[group]){
      this.uploadedFiles[group] = [];
      this.uploadedFiles[group].push({"documentId": event.documentId, "documentType": type});
    } else {
      let done = 0;
      for(let list of this.uploadedFiles[group]) {
        if(list.documentType == type){
          list.documentId = event.documentId;
          done = 1;
        }
      }
      if(done == 0) {
        this.uploadedFiles[group].push({"documentId": event.documentId, "documentType": type});
      }
    }
  }

  updatePhotoId(event) {
    for (let list of this.populateForm.photoIdTypes) {
      if (list.code == event.value) {
        let currDate = new Date(localStorage.getItem('currDate'));
        this.am.expirationDt = new Date(currDate.setFullYear(currDate.getFullYear() + list.defaultExpiryYear));
        if(list.defaultExpiryYear > 0) {
          this.pidExpiryDisable = true;
        } else {
          this.pidExpiryDisable = false;
          this.am.expirationDt = '';
        }
        if(list.maxLength > 0) {
          this.amForm.get('cardLic').setValidators([Validators.required,Validators.pattern('^[0-9a-zA-Z]{'+list.maxLength+'}$')]);
        } else {
          this.amForm.get('cardLic').setValidators([Validators.required]);
        }
        break;
      }
    }
  }

  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        for (var index = 0; index < addOn.length; index++) {
          if (addOn[index].status != 'L' && addOn[index].status != 'R' && addOn[index].status != 'S') {
            if (addOn[index].cardHolderNbr != cardholderNbr){
              this.messageService.add({ severity: 'error', summary: 'Add Add-on', detail: 'Mobile number is already used by another card holder(' + addOn[index].firstName + '), please change the mobile number.' });
              return false;
            }
          }
        }
      }
    } 
    return true;
  }

  saveAMapi() {
    if(this.uploadedFiles.cardHolderDocuments && this.uploadedFiles.cardHolderDocuments.length != 0) {
      this.uploadedFiles.cardHolderDocuments.forEach((list, i) => {
        if(list.documentType == "PHOTO") {
          this.am.cardHolderDocuments[0] = list;
        } else if(list.documentType == "PHOTO PROOF") {
          this.am.cardHolderDocuments[1] = list;
        }
      });
    }
    this.nms.saveAM(this.am).subscribe((res: any) => {
      this.inProcess = false;
      if(res.code == "SUCCESS") {
        this.am.cardHolderNbr = res.response.cardHolderNbr;
        this.ref.close(this.am);
      }
    }, err => {
      this.inProcess = false;
      console.error('ERROR', err);
    });
  }

  saveAM() {
    if(!this.inProcess) {
      this.inProcess = true;
      if(this.amForm.valid) {
        if(this.config.data.pmPhone != this.am.phoneNbr) {          
          if (!this.isPhoneNumberUnique(this.am.phoneNbr, this.am.cardHolderNbr)){
            this.inProcess = false;
            return;
          }
          if(this.uploadedFiles.cardHolderDocuments) {
            for(let list of this.uploadedFiles.cardHolderDocuments) {
              if(!list.ustatus) {
                this.amFormValid = false;
                this.inProcess = false;
                return;
              }
            }
            var photo = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO");
            var photoProof = this.uploadedFiles.cardHolderDocuments.filter(proj => proj.documentType === "PHOTO PROOF");
            if (photo[0].length == 0 || photoProof.length == 0) {
              this.amFormValid = false;
              this.inProcess = false;
              return;
            }
          } else {
            this.amFormValid = false;
            this.inProcess = false;
            return;
          }
          this.saveAMapi();
        } else {
          this.inProcess = false;
          this.msgToast('Phone number same as primary phone number');
        }
      } else {
        this.inProcess = false;
        if(this.amForm.get('status').value == "DRAFT") {
          if(this.amForm.get('firstName').valid && this.amForm.get('lastName').valid && this.amForm.get('mobile').valid && this.amForm.get('relation').valid) {
            if(this.config.data.pmPhone == this.am.phoneNbr) {   
              this.inProcess = false;
              this.msgToast('Phone number same as primary phone number');
              return;
            }
            if (!this.isPhoneNumberUnique(this.am.phoneNbr, this.am.cardHolderNbr)){
              this.inProcess = false;
              return;
            }
            this.saveAMapi();
          } else {
            this.draftMandatory = false;
            this.msgToast('Please fill all mandatory fields');
          }
        } else {
          this.amFormValid = false;
          if (this.amForm.get('mailId').valid) {
            this.msgToast('Please fill all mandatory fields');
          } else {
            this.msgToast('Invalid Email ID');
          }
        }
      }
    }
  }

  getCountyByPincode(pincode) {
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {
        if (res.code === "SUCCESS") {
            this.amCountyList = [];
            this.amCountyList = res.response.countyNames;
            if (this.amCountyList.indexOf(this.am.countyName) < 0) {
              this.amCountyList.push(this.am.countyName);
            }
        } 
      });
    }
  }

  msgToast(msg) {
    this.messageService.add({ severity: 'error', summary: 'Add Addon Member', detail: msg });
  }

  
  changeState(state){

      this.amCityList = [];

    this.nms.getCityByState(state).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
          this.amCityList = res.response;
      }
    });
  }

  changeCity( cityName){
      this.amCountyList = [];

    this.nms.getCountyListByCity(cityName).subscribe((res: any) => {
      if (res.code === "SUCCESS") {
          this.amCountyList = res.response;
      }
    });
  }

  populateLocation(res) {
    this.am.stateProvCode = "";
    this.am.cityName = "";
    this.amStateList = [];
    this.amCityList = [];
    this.amCountyList = [];
    this.am.countyName = "";

    this.amStateDropDisable = true;
    this.amCityDropDisable = true;    
    this.amStateList.push(res.stateName);
    this.am.stateProvCode = res.stateName;
    this.amCityList.push(res.cityName);
    this.am.cityName = res.cityName;
    this.amCountyList = res.countyNames;
  }

  getLocationByPincode(pincode, isDirty){
    if (!isDirty) {
      return;
    }
    if (pincode != undefined && pincode.toString().length == 6) {
      this.nms.getLocationByPincode(pincode).subscribe((res: any) => {
     
        if (res.code === "SUCCESS") {
          this.populateLocation(res.response);
        } else {
          this.messageService.add({ severity: 'info', summary: 'Add Add-on', detail: 'Select State and City.' });
         
            this.amStateList = [];
            this.amCityList = [];
            this.amCountyList = [];
            this.amStateDropDisable = false;
            this.amCityDropDisable = false;
            this.am.cityName = "";
            this.am.stateProvCode = "";
            this.am.countyName = "";
            this.amStateList = this.populateForm.states;
          
        }
      });
    }
  }
}